<template>
  <main>
    <div :class="style.calendar">
      <div :class="style.monthList">
        <h4
          :class="selectedMonthStr == month ? style.active : ''"
          v-for="(dataMonth, month) in availableMonths"
          @click="setSelectedMonth(dataMonth, month)"
          v-text="month.split(' ')[0]"
        />
      </div>
      <div :class="style.week">
        <div v-for="(dayName, dayNum) in weekDayName">
          <div :class="style.day">
            <span
              :style="{
                color: dayNum == 6 || dayNum == 5 ? 'red' : 'black'
              }"
              v-text="dayName"
              :class="style.notActive"
              style="opacity: 0.6"
            />
          </div>
        </div>
      </div>
      <div v-for="week in selectedMonth" :class="style.week">
        <div v-for="weekday in week" :class="style.day">
          <div v-for="(dataTime, day) in weekday">
            <span
              v-if="Object.keys(dataTime).length != 0"
              :class="selectedDayStr == day ? style.active : ''"
              @click="setSelectedDay(dataTime, day)"
              v-text="day"
            />
            <span :class="style.notActive" v-else v-text="day" />
          </div>
        </div>
      </div>
      <div v-if="Object.keys(selectedDay).length != 0" :class="style.timeList">
        <div v-for="(timeArr, timeOfDay) in selectedDay">
          <p v-text="timeOfDay" />
          <div>
            <span
              v-for="time in timeArr"
              :class="selectedTime == time ? style.active : ''"
              @click="setSelectedTime(time)"
              :key="time"
              v-text="time"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      @click="setConsultation()"
      :class="style.service + ' ' + style.consultationTime"
    >
      <div v-text="'Нет подходящего времени'" />
      <div :class="style.choiceService" />
    </div>
  </main>
</template>
<script lang="ts">
import style from "../StyleWidget.module.scss";
import {defineComponent} from "vue";
import type {doctor} from "@/page/onlineAppointment/doctors/DoctorsType";
import type {
  AvailableMonths,
  TimeOfDay,
  appointment,
  MonthStructure,
  TimeSlotsByDay
} from "../WidgetTypes";
import {getMonth} from "../ScriptsWidget";
export default defineComponent({
  name: "CalendareWidget",
  data() {
    return {
      style,
      weekDayName: ["ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ", "ВС"],
      selectedMonth: {} as MonthStructure,
      selectedDay: {} as Record<string, TimeSlotsByDay[TimeOfDay]>,
      selectedMonthStr: "",
      selectedDayStr: "" as string | number,
      selectedTime: "",
      availableMonths: {} as Record<string, MonthStructure>,
      available: {} as Record<string, Record<string, boolean>>,
      specializationSelected: "",
      serviceSelected: "",
      getMonth
    };
  },
  mounted() {
    this.prepairAvailableMonths();
  },
  methods: {
    setConsultation() {
      this.$widgetStore.updateConsultation(true);
    },
    setSelectedMonth(data: MonthStructure, month: string) {
      this.selectedMonth = data;
      this.selectedMonthStr = month;
      this.$widgetStore.setSelectedMonthStr(month);
    },
    setSelectedDay(
      data: Record<string, TimeSlotsByDay[TimeOfDay]>,
      day: string | number
    ) {
      this.selectedDay = data;
      this.selectedDayStr = String(day);
      this.$widgetStore.setSelectedDayStr(this.selectedDayStr);
    },
    setSelectedTime(time: string) {
      this.selectedTime = time;
      this.$widgetStore.setSelectedTime(time);
      this.$widgetStore.setSelectedStage(this.selectedStage + 1);
    },
    getWeekday(id: number) {
      const dayList = [
        "Понедельник",
        "Вторник",
        "Среда",
        "Четверг",
        "Пятница",
        "Суббота",
        "Воскресение"
      ];
      return dayList[id];
    },
    declensionMounth(mounth: string) {
      const monthList: Record<string, string> = {
        Январь: "января",
        Февраль: "февраля",
        Март: "марта",
        Апрель: "aпреля",
        Май: "мая",
        Июнь: "июня",
        Июль: "июля",
        Август: "aвгуста",
        Сентябрь: "cентября",
        Октябрь: "октября",
        Ноябрь: "ноября",
        Декабрь: "декабря"
      };
      return monthList[mounth];
    },

    getAvailableMonths(appointment: appointment | null = null) {
      function getDateSplit(date: string) {
        let yearMountDay;
        let month;
        let year;
        let day;
        if (date.includes("-")) {
          yearMountDay = date.split("-");
          month = parseInt(yearMountDay[1]);
          year = parseInt(yearMountDay[0]);
          day = parseInt(yearMountDay[2]);
        } else {
          yearMountDay = date.split(".");
          month = parseInt(yearMountDay[1]);
          year = parseInt(yearMountDay[2]);
          day = parseInt(yearMountDay[0]);
        }
        return {year, month, day};
      }
      if (appointment == undefined) {
        const doctor = this.getDoctors.find(
          (doc) => doc._id === this.chose.doctor._id
        );

        appointment = doctor?.appointment ?? null;
      }

      let mounthList = new Set<string>();
      if (appointment != null) {
        Object.keys(appointment).forEach((appointmentKey) => {
          const {month, year} = getDateSplit(appointmentKey);
          mounthList.add(month + " " + year);
        });
      }

      let months: AvailableMonths = {};
      mounthList.forEach((monthAndYear) => {
        const mountYear = monthAndYear.split(" ");
        const month = parseInt(mountYear[0]);
        const monthDate = month - 1;
        const monthStr = this.getMonth(month);
        const year = parseInt(mountYear[1]);
        const monthAndYearStr = monthStr + " " + year;
        const maxDayMonth = 32 - new Date(year, month - 1, 32).getDate();
        for (let day = 1; day <= maxDayMonth; day++) {
          const dayStr = day < 10 ? "0" + day : String(day);
          const date = new Date(year, monthDate, Number(dayStr));
          const weekday = date.getDay() == 0 ? 6 : date.getDay() - 1;
          const weekOfMonth =
            date.getDay() == 0
              ? date.getWeekOfMonth() - 1
              : date.getWeekOfMonth();
          if (months[monthAndYearStr] == undefined) {
            months[monthAndYearStr] = [];
          }
          if (months[monthAndYearStr][weekOfMonth] == undefined) {
            months[monthAndYearStr][weekOfMonth] = [];
          }
          if (months[monthAndYearStr][weekOfMonth][weekday] == undefined) {
            months[monthAndYearStr][weekOfMonth][weekday] = {};
          }
          if (months[monthAndYearStr][weekOfMonth][weekday][day] == undefined) {
            months[monthAndYearStr][weekOfMonth][weekday][day] = {};
          }
        }
      });
      if (appointment != null) {
        Object.entries(appointment).forEach((appointmentItem) => {
          const {year, month, day} = getDateSplit(appointmentItem[0]);
          const date = new Date(year, Number(month) - 1, day);
          const monthAndYear = this.getMonth(month) + " " + year;
          const weekday = date.getDay() == 0 ? 6 : date.getDay() - 1;
          const weekOfMonth =
            date.getDay() == 0
              ? date.getWeekOfMonth() - 1
              : date.getWeekOfMonth();
          Object.entries(appointmentItem[1])
            .filter((t) => {
              return t[1] == false;
            })
            .forEach((timeArr) => {
              let time = timeArr[0];
              const hoursToday = time.split(":").map((t) => {
                return Number(t);
              })[0];
              let timeOfDay: TimeOfDay;
              if (hoursToday >= 5 && hoursToday < 12) {
                timeOfDay = "Утро";
              } else if (hoursToday >= 12 && hoursToday < 17) {
                timeOfDay = "День";
              } else if (hoursToday >= 17 && hoursToday < 22) {
                timeOfDay = "Вечер";
              } else {
                timeOfDay = "Ночь";
              }
              if (
                months[monthAndYear][weekOfMonth][weekday][day] == undefined
              ) {
                months[monthAndYear][weekOfMonth][weekday][day] = {};
              }
              if (
                months[monthAndYear][weekOfMonth][weekday][day][timeOfDay] ==
                undefined
              ) {
                months[monthAndYear][weekOfMonth][weekday][day][timeOfDay] = [];
              }
              const [month, year] = monthAndYear.split(" ");
              let [currentDateStr, currentTime] = new Date()
                .toISOString()
                .split("T");

              let currentDate: number = new Date(currentDateStr).getTime();

              let [currentHoursStr, currentMinutesStr] = currentTime
                .substring(0, 5)
                .split(":");

              let [hoursStr, minutesStr] = time.split(":");

              const timeZone: number = -(new Date().getTimezoneOffset() / 60);

              let currentHours: number = Number(currentHoursStr) + timeZone;
              let currentMinutes: number = Number(currentMinutesStr);
              let hours: number = Number(hoursStr);
              let minutes: number = Number(minutesStr);

              let timeСomparison: boolean =
                currentHours * 60 + currentMinutes < hours * 60 + minutes;

              let dateStr: number = new Date(
                `${year}-${this.getMonth(month)}-${day}`
              ).getTime();

              let path =
                months[monthAndYear][weekOfMonth][weekday][day][timeOfDay];
              if (!path) {
                return;
              }
              if (
                (currentDate === dateStr && timeСomparison) ||
                currentDate < dateStr
              ) {
                path.push(time);
              }

              if (path.length === 0) {
                delete months[monthAndYear][weekOfMonth][weekday][day][
                  timeOfDay
                ];
              }
            });
        });
      }

      let monthsList = Object.keys(months);
      let getMonth = this.getMonth;
      function sort(a: string, b: string): number {
        let aSplit = a.split(" ");
        let bSplit = b.split(" ");
        if (Number(aSplit[1]) > Number(bSplit[1])) {
          return 1;
        }
        a = String(getMonth(aSplit[0]));
        b = String(getMonth(bSplit[0]));
        if (Number(a) > Number(b)) {
          return 1;
        } else if (Number(a) == Number(b)) {
          return 0;
        }
        return -1;
      }

      let sortMonths: Record<string, MonthStructure> = {};

      monthsList.sort(sort).forEach((m: string) => {
        sortMonths[m] = months[m];
      });
      let firstMonth = Object.entries(sortMonths)[0];
      this.setSelectedMonth(firstMonth[1], firstMonth[0]);
      return sortMonths;
    },
    setAvailable(appointment?: Record<string, Record<string, boolean>>) {
      if (!appointment) return;

      Object.keys(appointment).forEach((Datekey) => {
        if (this.available[Datekey] == undefined) {
          this.available[Datekey] = {};
        }
        Object.keys(appointment[Datekey]).forEach((timeKey) => {
          if (this.available[Datekey][timeKey] == undefined) {
            this.available[Datekey][timeKey] = false;
          } else if (this.available[Datekey][timeKey] == true) {
            this.available[Datekey][timeKey] = appointment[Datekey][timeKey];
          }
        });
      });
    },
    prepairAvailableMonths() {
      this.available = {};
      if (this.chose.doctor.id == "All") {
        this.getDoctors.forEach((doctor) => {
          if (
            this.specializationSelected ||
            this.serviceSelected ||
            this.chose.DoctorService
          ) {
            if (
              doctor.specialization.indexOf(this.specializationSelected) != -1
            ) {
              this.setAvailable(
                doctor.appointment as
                  | Record<string, Record<string, boolean>>
                  | undefined
              );
            } else if (
              Object.keys(doctor.service).indexOf(this.serviceSelected) != -1 ||
              this.chose.DoctorService
            ) {
              if (this.chose.DoctorService) {
                let serviceList: {
                  name: string;
                  checked: boolean;
                }[] = [];
                Object.values(doctor.service).forEach((arr) => {
                  serviceList = serviceList.concat(arr);
                });
                if (
                  serviceList.filter((s) => {
                    return (
                      s.name ==
                      this.chose.DoctorService.slice(0, -2).replaceAll(" ", " ")
                    );
                  }).length != 0
                ) {
                  this.setAvailable(
                    doctor.appointment as
                      | Record<string, Record<string, boolean>>
                      | undefined
                  );
                }
              } else {
                this.setAvailable(
                  doctor.appointment as
                    | Record<string, Record<string, boolean>>
                    | undefined
                );
              }
            }
          } else {
            this.setAvailable(
              doctor.appointment as
                | Record<string, Record<string, boolean>>
                | undefined
            );
          }
        });
        this.availableMonths = this.getAvailableMonths(this.available);
      } else {
        this.availableMonths = this.getAvailableMonths();
      }
    }
  },
  computed: {
    chose() {
      return this.$widgetStore.getChose;
    },
    getDoctors(): doctor[] {
      return this.$widgetStore.getDoctors;
    },
    selectedStage() {
      return this.$widgetStore.getSelectedStage;
    }
  }
});
</script>
